export const routes = {
    "/immunisationHistory": {
        title: "Immunisation History",
        "/immunisationRecord": {
            title: "Immunisation Record",
        }
    }
};
